/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CarrierRestrictionDirection } from "./CarrierRestrictionDirection";
import {
  CarrierRestrictionDirectionFromJSON,
  CarrierRestrictionDirectionFromJSONTyped,
  CarrierRestrictionDirectionToJSON,
  CarrierRestrictionDirectionToJSONTyped,
} from "./CarrierRestrictionDirection";

/**
 *
 * @export
 * @interface CarrierQuotingRestrictionHistory
 */
export interface CarrierQuotingRestrictionHistory {
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionHistory
   */
  historyId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionHistory
   */
  carrierQuotingRestrictionId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionHistory
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionHistory
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionHistory
   */
  restrictionType?: string;
  /**
   *
   * @type {CarrierRestrictionDirection}
   * @memberof CarrierQuotingRestrictionHistory
   */
  direction?: CarrierRestrictionDirection;
  /**
   *
   * @type {Array<string>}
   * @memberof CarrierQuotingRestrictionHistory
   */
  postalCodes?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionHistory
   */
  changeType?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierQuotingRestrictionHistory
   */
  updatedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionHistory
   */
  updatedBy?: string;
}

/**
 * Check if a given object implements the CarrierQuotingRestrictionHistory interface.
 */
export function instanceOfCarrierQuotingRestrictionHistory(
  value: object,
): value is CarrierQuotingRestrictionHistory {
  return true;
}

export function CarrierQuotingRestrictionHistoryFromJSON(
  json: any,
): CarrierQuotingRestrictionHistory {
  return CarrierQuotingRestrictionHistoryFromJSONTyped(json, false);
}

export function CarrierQuotingRestrictionHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierQuotingRestrictionHistory {
  if (json == null) {
    return json;
  }
  return {
    historyId: json["historyId"] == null ? undefined : json["historyId"],
    carrierQuotingRestrictionId:
      json["carrierQuotingRestrictionId"] == null
        ? undefined
        : json["carrierQuotingRestrictionId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    name: json["name"] == null ? undefined : json["name"],
    restrictionType:
      json["restrictionType"] == null ? undefined : json["restrictionType"],
    direction:
      json["direction"] == null
        ? undefined
        : CarrierRestrictionDirectionFromJSON(json["direction"]),
    postalCodes: json["postalCodes"] == null ? undefined : json["postalCodes"],
    changeType: json["changeType"] == null ? undefined : json["changeType"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    updatedBy: json["updatedBy"] == null ? undefined : json["updatedBy"],
  };
}

export function CarrierQuotingRestrictionHistoryToJSON(
  json: any,
): CarrierQuotingRestrictionHistory {
  return CarrierQuotingRestrictionHistoryToJSONTyped(json, false);
}

export function CarrierQuotingRestrictionHistoryToJSONTyped(
  value?: CarrierQuotingRestrictionHistory | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    historyId: value["historyId"],
    carrierQuotingRestrictionId: value["carrierQuotingRestrictionId"],
    carrierIdentifier: value["carrierIdentifier"],
    name: value["name"],
    restrictionType: value["restrictionType"],
    direction: CarrierRestrictionDirectionToJSON(value["direction"]),
    postalCodes: value["postalCodes"],
    changeType: value["changeType"],
    updatedAt: value["updatedAt"],
    updatedBy: value["updatedBy"],
  };
}
